import React from "react";
import logo from "../../../assets/img/ht_logo_orange.svg";
import "./htLoader.scss";
import PropTypes from "prop-types";

const HTLoader = ({ loaderText = "Loading..." }) => {
  return (
    <div className="ht-loading position-absolute top-50 start-50 translate-middle">
      <img alt="Hotel Trader loading" src={logo} width="61" />
      <div className="shine"></div>
      <div className="ht-loader-text">{loaderText}</div>
    </div>
  );
};

HTLoader.propTypes = {
  loaderText: PropTypes.string,
};

export default HTLoader;
